export default __webpack_public_path__ + "static/media/GPAOrganizationalChart(1).26ee30a2.png";